export const LOAD_FORM_DATA = 'LOAD_FORM_DATA'
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA'
export const LOAD_MAPPINGS = 'LOAD_MAPPINGS'
